import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import { Alert } from "reactstrap";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  checkbox: {
    width: "25px",
    height: "25px",
  },
  title: {
    textAlign: "center",
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const EditSecondarySite = () => {
  const { siteId } = useParams();
  const classes = useStyles();

  const [formData, setFormData] = useState({
    site: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken(`api/SecondarySites/${siteId}`)
      .then((response) => response.json())
      .then((data) =>
        setFormData({
          site: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {formData.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <EditForm formData={formData} />
      )}
    </>
  );
};

const EditForm = ({ formData: formData }) => {
  const classes = useStyles();
  const history = useNavigate();

  const site = formData.site;

  const sSiteData = {
    primarySiteId: site.primarySiteId,
    name: site.name,
    country: site.country,
    state: site.state,
    city: site.city,
    dnsSiteCode: site.dnsSiteCode,
  };

  const [submitData, setSubmitData] = useState(sSiteData);

  const myChangeHandler = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    setSubmitData({
      ...submitData,
      [name]: value,
    });
  };

  const handleCancel = () => {
    history(`/site/manage`);
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (submitData.dnsSiteCode === sSiteData.dnsSiteCode) {
      sendAlert(`No Changes Made`, "warning");
      return;
    }

    fetchWithToken(`api/SecondarySites/${site.id}`, "PUT", submitData).then(
      (data) => {
        console.log("Response", data); // JSON data parsed by `data.json()` call
        history(`/site/manage`);
      }
    );
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });

    const timer = setTimeout(() => {
      setAlertMessage({
        message: "",
        varient: "",
        active: false,
      });
    }, 4500);
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert color={alertMessage.varient}>{alertMessage.message}</Alert>
            )}
            <CardContent>
              <form onSubmit={submitHandler}>
                <Typography
                  sx={{ fontSize: 14 }}
                  style={{ margin: "20px", fontSize: "1.5em" }}
                  color="text.secondary"
                  gutterBottom
                >
                  Edit Secondary Site: {site.id}
                </Typography>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="dnsSiteCode" class="col-sm-3 col-form-label">
                    <h6>DNS Site Code:</h6>
                  </label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      style={{ fontSize: "1em" }}
                      class="form-control"
                      name="dnsSiteCode"
                      maxlength="3"
                      defaultValue={site.dnsSiteCode}
                      onChange={myChangeHandler}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-3 col-form-label">
                    <h6>Primary Site ID:</h6>
                  </label>
                  <div class="col-sm-9" style={{ paddingTop: "8px" }}>
                    <h6>{site.primarySiteId}</h6>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-3 col-form-label">
                    <h6>Name:</h6>
                  </label>
                  <div class="col-sm-9" style={{ paddingTop: "8px" }}>
                    <h6>{site.name}</h6>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-3 col-form-label">
                    <h6>Country:</h6>
                  </label>
                  <div class="col-sm-9" style={{ paddingTop: "8px" }}>
                    <h6>{site.country}</h6>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-3 col-form-label">
                    <h6>State:</h6>
                  </label>
                  <div class="col-sm-9" style={{ paddingTop: "8px" }}>
                    <h6>{site.state}</h6>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-3 col-form-label">
                    <h6>City:</h6>
                  </label>
                  <div class="col-sm-9" style={{ paddingTop: "8px" }}>
                    <h6>{site.city}</h6>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "20px" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    className={classes.button}
                    color="primary"
                  >
                    Update
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default EditSecondarySite;
